import { Device } from "@capacitor/device";
import { logEvent } from "./Analytics";
import { EVENT, SCREEN } from "./constants.analytics";
import { APP_VERSION } from "./constants";

export const logError = async (error: Error, info: { componentStack: string }) => {
  const errorLogData = JSON.stringify(info).replace('\"', '').replace("componentStack\":\"", "").replace("{", "").replace("}", "").trim();
  const stacktrace = errorLogData.split("\\n").map(s => s.trim());
  const stacktraceObj = stacktrace.reduce(function (array: any, item: string, index: number) {
    array[index] = item;
    return array;
  }, {});
  // const stacktraceObj = stacktrace.map((value, index) => ({stacktrace: index, value}));
  // console.log("stacktraceObj:::", stacktraceObj[2]);

  Device.getInfo().then((deviceInfo: any) => {
    const deviceInformation = "Platform:" + deviceInfo.platform + " OS:" + deviceInfo.operatingSystem + " osVersion:" + deviceInfo.osVersion
      + " Model:" + deviceInfo.model + " Name:" + deviceInfo.name + " appVersion:" + APP_VERSION;
    const deviceInformation1 = "browserName:" + deviceInfo.manufacturer + " browserVersion:" + deviceInfo.webViewVersion;
    const analyticsObject = {
      screen: SCREEN.OOPS_PAGE,
      "lead": stacktrace.toString().slice(0, 99),
      "device_info": deviceInformation,
      "device_info_browser": deviceInformation1,
      // "stacktrace": "<stack trace if feasible to capture>",
      // "loadID": "<loadId if applicable>",
      // "shipmentID": "<shipmentId if applicable>",
      // "<reference key>":"<reference value - iterate for all keys added>"
    };
    const logEventObj = { ...analyticsObject, ...stacktraceObj };
    stacktrace.length > 1 && logEvent(EVENT.UE_OOPS_PAGE_OCCURRENCE, logEventObj);
  });
}